import { t } from 'i18next';
import { Color } from 'three';

import { ContextMenuItem } from '../../../../../../../react/components/skyview/context-menu';
import { isDefined } from '../../../../../../../utils/variables';
import { RevertChange } from '../../../../../../elements/design/design-node/design-node';
import { findPointIdFromIntersection } from '../../../../../../elements/design/design-node/utils/point-node';
import { DesignTool } from '../../../../../design-tool';
import { addAndCommitAction } from '../../utils/actions';
import { removePoint } from '../../utils/point';
import { deselect } from '../../utils/select';

export const deletePoint = (tool: DesignTool): ContextMenuItem => {
  const pointId = findPointIdFromIntersection(tool.asset.designNode, tool.intersection);
  const oldPoint = tool.intersection?.point;
  const disabled = !isDefined(pointId) || !isDefined(oldPoint);

  return {
    title: t('contextMenu.deletePoint', { ns: 'skyviewDesign' }),
    action: () => {
      let changes: RevertChange[] = [];

      if (disabled) {
        return;
      }

      addAndCommitAction(tool, {
        commit: () => {
          changes = removePoint(tool.asset.designNode, pointId);
          deselect(tool);
          tool.asset.designNode.refresh();
          tool.asset.refreshMetadata();
        },
        rollback: () => {
          tool.asset.designNode.revert(changes);
          tool.asset.designNode.refresh();
          tool.asset.refreshMetadata();
        },
      });
      tool.cursorPoint.setColor(new Color(0xffff00));
      tool.contextMenuCallback?.();
    },
    disabled,
    hotkey: 'Delete',
  };
};
